import React from "react";
import { localizeDigits, useStoreLanguage } from "../../../features/store-language/i18n.ts";

export interface VariantDetailsData {
  id: number;
  addressTitle: string;
  title: string;
  code?: string;
  attributes: {
    attributeDefinitionId: number;
    attributeValueId: number;
    attributeTitle: string;
    title: string;
  }[];
}

export default function VariantDetails({ variant }: { variant: VariantDetailsData }) {
  useStoreLanguage();
  if (variant.attributes.length === 0) {
    return null;
  }

  return (
    <div className="schema-variant-details">
      <dl>
        {variant.attributes.map(function (attribute) {
          return (
            <div key={`${attribute.attributeDefinitionId}-${attribute.attributeValueId}`}>
              <dt>{attribute.attributeTitle}</dt>
              <dd>{localizeDigits(attribute.title)}</dd>
            </div>
          );
        })}
      </dl>
    </div>
  );
}
